import {
  ActionIcon,
  Tooltip,
  useComputedColorScheme,
  useMantineColorScheme,
} from "@mantine/core";
import { IconMoon, IconSun } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export default function ColorSchemeToggle() {
  const { t } = useTranslation("common");
  const { setColorScheme } = useMantineColorScheme();
  const computed = useComputedColorScheme("dark", { getInitialValueInEffect: true });
  const isDark = computed === "dark";

  return (
    <Tooltip
      label={isDark ? t("nav.theme.switchToLight") : t("nav.theme.switchToDark")}
      position="bottom"
    >
      <ActionIcon
        variant="subtle"
        size="lg"
        aria-label={t("nav.theme.toggle")}
        onClick={() => setColorScheme(isDark ? "light" : "dark")}
      >
        {isDark ? <IconSun size={20} /> : <IconMoon size={20} />}
      </ActionIcon>
    </Tooltip>
  );
}
